export default __webpack_public_path__ + "static/media/screen-2.2948b6a7.jpg";